import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SplitMaxPointsRewardCalculationTypeEditor() {
    const { t } = useTranslation();

    return <Stack>
        <Typography variant="caption">
            {t("actionModules.rewardCalculationType.splitMaxPoints.description")}
        </Typography>
    </Stack>
}